import React from "react";
import { useParams } from "react-router-dom";
import AppContainer from "../../components/AppContainer";
import NavBar from "../../components/NavBar/index";
import SpotContainer from "./SpotContainer";
import TideTable from "../../components/TideTable";

const Spot = () => {
  let { spotName } = useParams();
  return (
    <AppContainer>
      <SpotContainer spotName={spotName} />
      <TideTable spotName={spotName} />
      <NavBar />
    </AppContainer>
  );
};

export default Spot;
